mutation RetireDripSequence($input: DripSequenceRetireInput!) {
    dripSequenceRetire(input: $input) {
        dripSequence {
            id
        }
    }
}
